import { IDanhSachNoTotNghiepViewModel } from "../../../model/response/xet-tot-nghiep/IDanhSachNoTotNghiepViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachNoTotNghiepActionsObj = {
    LOAD_BY_DOT_XET_START:0 ,
    LOAD_BY_DOT_XET_SUCCESS: {} as IDanhSachNoTotNghiepViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",
}

export const eDanhSachNoTotNghiepActionIds = generateActionTypeIds(eDanhSachNoTotNghiepActionsObj, "DANH_SACH_NO_TOT_NGHIEP");
export type IDanhSachNoTotNghiepActionTypes = IGenericActionType<typeof eDanhSachNoTotNghiepActionsObj, "DANH_SACH_NO_TOT_NGHIEP">;